import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap, tap, mapTo } from 'rxjs/operators';
import { interval, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getUnits, updateUnitName } from '../actions/units.actions';
import * as UnitSharedActions from '../actions/units-shared.actions';
import { UnitsService } from '../../../units/services/units.service';
import { getUnitsFailure, getUnitsSuccess, updateUnitNameFailure, updateUnitNameSuccess } from '../actions/units-api.actions';
import { getPositions } from '../actions/positions.actions';
import { cacheLifeTime } from '../../../shared/config';
import { LoadingBarState } from '@ngx-loading-bar/core/loading-bar.state';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable()
export class UnitsEffects {

  getUnits$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getUnits, UnitSharedActions.getData),
      switchMap(action =>
        this._unitsService.getUnits()
          .pipe(
            exhaustMap(units => of(getUnitsSuccess({ units: units }))),
            catchError(error => of(getUnitsFailure({ error })))
          )
      )
    )
  );

  updateUnitName$ = createEffect(() =>
    this._actions$.pipe(
      ofType(updateUnitName),
      tap(() => this._loader.start()),
      switchMap((action: any) => this._unitsService.updateUnitName(action.unitId, action.name).pipe(
        exhaustMap((data) => of(updateUnitNameSuccess({ data: data }))),
        catchError(error => of(updateUnitNameFailure({ error }))),
        tap(() => this._loader.complete()),
      ))
    )
  );

  getUnitsSuccess$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getUnitsSuccess),
      switchMap((action: any) => of(getPositions({ unitIds: action.units.map(x => x['unitId']) })))
    )
  );

  persistUnits$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getUnitsSuccess),
      tap((action) => {
        try {
          localStorage.setItem(`${environment.storagePrefix}.cachedUnits`, JSON.stringify(action.units));
        } catch { }
      })
    ), { dispatch: false }
  );

  // periodic clear action
  clear$ = createEffect(() =>
    interval(cacheLifeTime).pipe(
      mapTo(UnitSharedActions.clearData())
    )
  );

  // when clearData is emitted, dispatch getData
  getData$ = createEffect(() =>
    this._actions$.pipe(
      ofType(UnitSharedActions.clearData),
      mapTo(UnitSharedActions.getData())
    )
  );

  private _loader: LoadingBarState;

  constructor(
    private _actions$: Actions,
    private _unitsService: UnitsService,
    private _loadingBar: LoadingBarService
  ) {
    this._loader = this._loadingBar.useRef('main');
  }
}